import { render } from "./sidebarCliente.vue?vue&type=template&id=21c5a4c6&scoped=true"
import script from "./sidebarCliente.vue?vue&type=script&lang=js"
export * from "./sidebarCliente.vue?vue&type=script&lang=js"

import "./sidebarCliente.vue?vue&type=style&index=0&id=21c5a4c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c5a4c6"]])

export default __exports__